"use client";

import { useTranslations } from "@i18n/provider";

type ConversationHeaderProps = {
  personaName: string;
  scenarioBadge: string;
  turnCount: number;
  onEnd: () => void;
};

export function ConversationHeader({
  personaName,
  scenarioBadge,
  turnCount,
  onEnd,
}: ConversationHeaderProps) {
  const { t } = useTranslations();

  return (
    <div className="flex items-center justify-between gap-2">
      <div className="min-w-0 flex-1">
        <p className="eyebrow truncate text-white/80">{scenarioBadge}</p>
        <h2 className="truncate font-display text-base font-semibold text-white">{personaName}</h2>
      </div>
      <div className="flex flex-shrink-0 items-center gap-2">
        <span className="rounded-full bg-speaking-tint px-2 py-0.5 font-display text-xs font-bold text-speaking-fg">
          {t("agent.conversation.turnCounter", { current: String(turnCount) })}
        </span>
        <button
          type="button"
          onClick={onEnd}
          aria-label={t("agent.conversation.endAria")}
          className="min-h-[44px] min-w-[44px] rounded-lg px-2 text-sm font-semibold text-white/80 transition-colors hover:text-white"
        >
          {t("agent.conversation.end")}
        </button>
      </div>
    </div>
  );
}
